export class FindAllByNameContainingAndCreatorId {
    name = '';
    creatorId?: number;

    static of(o: any) {
        return Object.assign(new FindAllByNameContainingAndCreatorId(), o);

    }
}
